"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hslaToRgba = exports.hslToRgb = void 0;
var tslib_1 = require("tslib");
var tinycolor_1 = require("@ctrl/tinycolor");
var number_to_rgb_value_1 = require("../from-number/number-to-rgb-value");
var hslToRgb = function (_a) {
    var _b = tslib_1.__read(_a, 3), h = _b[0], s = _b[1], l = _b[2];
    var tc = new tinycolor_1.TinyColor({ h: h, s: s, l: l });
    var _c = tc.toRgb(), r = _c.r, g = _c.g, b = _c.b;
    return [(0, number_to_rgb_value_1.numberToRgbValue)(r), (0, number_to_rgb_value_1.numberToRgbValue)(g), (0, number_to_rgb_value_1.numberToRgbValue)(b)];
};
exports.hslToRgb = hslToRgb;
var hslaToRgba = function (_a) {
    var _b = tslib_1.__read(_a, 4), h = _b[0], s = _b[1], l = _b[2], a = _b[3];
    var _c = tslib_1.__read((0, exports.hslToRgb)([h, s, l]), 3), r = _c[0], g = _c[1], b = _c[2];
    return [r, g, b, a];
};
exports.hslaToRgba = hslaToRgba;
